import { API_UPDATE_NOTIFY } from "api/Notify-manage";
import { API_LIST_NOTIFY } from "api/Notify-manage";
import { API_ENABLE_DISABLE_NOTIFY } from "api/Notify-manage";
import { API_CREATE_NOTIFY } from "api/Notify-manage";
import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import { toast } from "react-toastify";
const NotificationManage = () => {
  const notifications = [
    {
      id: 1,
      title: "New Order",
      message: "New Order has been placed",
      slug: "new_order",
    },
    {
      id: 2,
      title: "Coupon Notification",
      message: "Get Product discount Coupon",
      slug: "coupon_notification",
    },
    {
      id: 3,
      title: "Order Confirmed",
      message: "Your order has been confirmed",
      slug: "order_confirmed",
    },
    {
      id: 4,
      title: "Order Picked",
      message: "Your order has been picked by delivery boy",
      slug: "order_picked",
    },
    {
      id: 5,
      title: "Order Processing",
      message: "Your order has been processed",
      slug: "order_processing",
    },
    {
      id: 6,
      title: "Order Cancelled",
      message: "Your order has been cancelled",
      slug: "order_cancelled",
    },
    {
      id: 7,
      title: "Order Delivered",
      message: "Your order has been delivered successfully",
      slug: "order_delivered",
    },
    {
      id: 8,
      title: "Driver Assigned",
      message: "Delivery boy has been assigned to your order",
      slug: "driver_assigned",
    },
  ];
  const [isUpdating, setIsUpdating] = useState(false);
  const [notifyId, setNotifyId] = useState(null); // Track the policy ID if updating

  const [notificationSettings, setNotificationSettings] = useState(
    notifications.map((notification) => ({
      ...notification,
      enabled: true,
      message: notification.message,
    }))
  );
  const handleToggle = async (index) => {
    const newSettings = [...notificationSettings];
    newSettings[index].enabled = !newSettings[index].enabled;
    setNotificationSettings(newSettings);
    try {
      const response = await API_ENABLE_DISABLE_NOTIFY(notifyId); // Make sure your API returns data in the expected format
      if (response) {
        toast?.success(response?.message);
        console.log("response", response);
      }
    } catch (error) {
      console.error("Failed to fetch privacy policy", error);
    }
  };
  const handleMessageChange = (index, newMessage) => {
    const newSettings = [...notificationSettings];
    newSettings[index].message = newMessage;
    setNotificationSettings(newSettings);
  };
  const fetchNotify = async () => {
    try {
      const response = await API_LIST_NOTIFY(); // Make sure your API returns data in the expected format
      if (response) {
        console.log("response", response);
        const notification = response?.customNotifications?.[0];
        console.log("notification", notification);

        setNotifyId(notification?._id); // Assume the policy object has an id
        setIsUpdating(true);
      }
    } catch (error) {
      console.error("Failed to fetch Notification", error);
    }
  };
  const handleUpdate = async (index) => {
    const notification = notificationSettings[index];
    const payload = {
      name: notification.title,
      message: notification.message,
      slug: notification.slug,
    };
    try {
      if (isUpdating) {
        const response = await API_UPDATE_NOTIFY(notifyId, payload);
        toast.success("Notification updated successfully!");
        console.log("Updated notification:", response.data);
      } else {
        const response = await API_CREATE_NOTIFY(payload);
        toast.success("Notification updated successfully!");
        console.log("Updated notification:", response.data);
      }
    } catch (error) {
      console.error("Error updating notification", error);
      toast.error("Failed to update notification.");
    }
  };
  useEffect(() => {
    fetchNotify();
  }, []);

  return (
    <div className="notification-management">
      {/* <h1>Notification Management</h1> */}
      <div className="notifications-container">
        {notificationSettings?.map((notification, index) => (
          <div key={notification.id} className="notification-card">
            <div className="card-header">
              <h2>{notification.title}</h2>
              <Switch
                onChange={() => handleToggle(index)}
                checked={notification?.enabled}
              />
            </div>
            <textarea
              className="notify-area"
              value={notification?.message}
              onChange={(e) => handleMessageChange(index, e.target.value)}
            />
            <button className="notify-btn" onClick={() => handleUpdate(index)}>
              Update
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default NotificationManage;
